export class BinRequest {

    idBinPk: number;
    bubBinesbubCatAccionBubCatAccion: number;
    bubBinesBubCatInstitucionesIdInstitucionPk: number;
    bubBinesBubCatTipoBinIdTipoBinPk: number;
    bubBinesBubCatBinEstatusIdEstatusPk: number;

    bin: string;
    usuarioAlta: string;
    usuarioMod: string;
    usuarioAutorizador: string;

    fchAlta: string;
    fchMod: string;
    fchAutorizacion: string;
    regTemp: string;
    binInicio: string;
    binFinal: string;
    institucion: string;
    institucionAnterior: string;
    fechaSolicitud: Date;
}

